/**
* youtubeのコンストラクタ
* @constructor
* @param {selector} - el jqueryセレクタ
*/
module.exports = YouTube = function(el){
	this.element = $(el);
	this.target = this.element.find('.js-youtube-embed');
	this.videoId = this.target.attr('data-video-id');
	this.win = $(window);
	this.checkDevice();
	this.resize();
	this.init();
};

/**
* initialize
*/
YouTube.prototype.init = function(){
	var self = this;

	this.element.append('<img class="-pic" src="//i.ytimg.com/vi/'+this.videoId+'/maxresdefault.jpg" alt="">');

	if(typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined'){
		this.ytLoaded = this.getYTapi();
		this.ytLoaded.done(function(){
			self.event();
		});
	}
};

/**
* get youtube iframe API
*/
YouTube.prototype.getYTapi = function(){
	var defer = $.Deferred();
	$.getScript('//youtube.com/player_api', function(){
		window.onYouTubeIframeAPIReady = function() {
			defer.resolve();
		};
	});
	return defer.promise();
};

/**
* event
*/
YouTube.prototype.event = function(){
	var self = this;

	$('.js-youtube-control').on('click', function(e){
		e.preventDefault();
		var embedId = $(this).next().attr('data-embed-id');
		var videoId = $(this).next().attr('data-video-id');
		if(self.device === 'pc'){
			$(this).parent().addClass('is-clicked');
			self.initYTPlayer(embedId, videoId);
		}else{
			self.initModal(embedId, videoId)
		}
	});
};

/**
* initialize YT player
* @param {string} - embedId iframe id
* @param {string} - videoId youtube video id
*/
YouTube.prototype.initYTPlayer = function(embedId, videoId){
	var self = this;
	this.ytPlayer = new YT.Player(embedId, {
		videoId: videoId,
		playerVars: {
			rel: 0,
			showinfo: 0,
			autoplay: 1
		},
		events: {
			'onReady': self.onPlayerReady,
			'onStateChange': self.onPlayerStateChange
		}
	});
};

YouTube.prototype.onPlayerReady = function(event){
	player.mute();
	var self = this;
};
YouTube.prototype.onPlayerStateChange = function(event){
	var self = this;
};

/**
* モーダル設定
* @param {string} - embedID iframeに付与されるID
* @param {string} - videoID YoutubeID
*/
YouTube.prototype.initModal = function(embedId, videoId){
	var self = this;

	var embedId = embedId + '_sp';

	// modal
	if(!$('.js-modal').length){
		var html = '';
		html += '<div class="modal js-modal">';
		html += '<div class="modal-iframe js-modal-content">';
		html += '<a href="#" class="modal-close c-bt js-modal-close"><span>閉じる</span></a>';
		html += '</div>';
		$('body').append('<div class="modal-overlay js-modal-overlay" />').append(html);
	};

	this.modal = $('.js-modal');
	this.modalOverlay = $('.js-modal-overlay');
	this.modalCloses = $('.js-modal-close, .js-modal-overlay');
	this.modalHtml = $('.js-modal-content');
	this.modalEmbed = $('.js-modal-embed');

	this.top = this.win.scrollTop();
	this.setModalPosition(this.top);
	this.modalOverlay.addClass('is-active');
	this.modal.addClass('is-active');
	if(!this.modalEmbed.length){
		this.modalHtml.prepend('<div class="js-modal-embed" id="' + embedId + '">');
	}

	this.initYTPlayer(embedId, videoId);

	this.modalOverlay.on('click',function(){
		self.removeModal();
		return false;
	});

	this.modal.on('click','.js-modal-close',function(){
		self.removeModal();
		return false;
	});
}

/**
* モーダル閉じる
*/
YouTube.prototype.removeModal = function(){
	this.modalOverlay.removeClass('is-active');
	this.modal.removeClass('is-active');
	this.modalHtml.children('iframe').remove();
}

/**
* モーダル位置調整
*/
YouTube.prototype.setModalPosition = function(_t){
	this.modal.css({
		'top': _t + this.win.height() / 2 - this.modal.height() / 2
	});
}

/**
* リサイズ
*/
YouTube.prototype.resize = function(){
	var self = this;
	var timer = false;
	this.win.on('resize', function(){
		if(timer !== false){
			clearTimeout(timer);
		}
		timer = setTimeout(function(){
			self.checkDevice();
			if($('.js-modal').length){
				self.top = self.win.scrollTop();
				self.setModalPosition(self.top);
			}
		},1000);
	});
};

/**
* デバイスチェック
*/
YouTube.prototype.checkDevice = function(){
	this.device = $('.header-logo-nrnl').css('position') == 'absolute' ? 'sp' : 'pc';
}




//////////////////
// WEBPACK FOOTER
// ./js/_modules/youTube.js
// module id = 9
// module chunks = 0